import * as React from "react";
import { WorkerTypes } from "./WorkerTypesPage";
import { WorkerTypesProvider } from "./context/WorkerTypesContext";

type Props = {};

const WorkerTypesPage = (props: Props) => {
	return (
		<WorkerTypesProvider>
			<WorkerTypes />
		</WorkerTypesProvider>
	);
};

export default WorkerTypesPage;
